import React, { useState } from 'react';
import { GiRadioactive } from "react-icons/gi";
import { HiOutlineQuestionMarkCircle } from "react-icons/hi2";
import { IoIosInformationCircleOutline } from "react-icons/io";
import Swal from 'sweetalert2';
import { isGodMode } from '../utils/permissions';
import { useStateContext } from '../context/StateContext';
import { useAuthContext } from '../whitaijiFrontendLibrary/auth/hooks/useAuthContext';
import { AuthContext } from '../context/AuthContext';

const TestButton = ({
  style,
  onClick = () => {},
  consoleData = {},
  copyId,
  size = 30,
  message = "",
  buttonId = ""
}) => {
  const {hideTestButtons } = useStateContext();
   const {user} = useAuthContext(AuthContext)

  const [isHovered, setIsHovered] = useState(false);

  const testFunction = (e) => {
    e?.stopPropagation?.();
    if (copyId) {
      navigator.clipboard.writeText(copyId);
    }
    onClick({ buttonId, console });
    console.log(buttonId, message, consoleData);
  };

    if(!isGodMode(user) || hideTestButtons) return null
  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      <div
        onClick={testFunction}
        onMouseEnter={(e) => {
          e?.stopPropagation?.();
          setIsHovered(true);
        }}
        onMouseLeave={(e) => {
          e?.stopPropagation?.();
          setIsHovered(false);
        }}
        rules={[isGodMode(user)]}
        style={{
          backgroundColor: "black",
          borderRadius: "100%",
          cursor: "pointer",
          margin: "10px",
          width: `${size}px`,
          height: `${size}px`,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          ...style
        }}
      >
        <GiRadioactive size={"100%"} color={copyId ? "orange" : "yellow"} />
      </div>

      {isHovered && message && (
        <div
          style={{
            position: "absolute",
            bottom: "100%",
            left: "50%",
            transform: "translateX(-50%)",
            marginBottom: "1px",
            backgroundColor: "black",
            color: "white",
            padding: "5px 5px",
            borderRadius: "4px",
            fontSize: "12px",
            whiteSpace: "nowrap",
            zIndex: 10,
            pointerEvents: "none",
          }}
        >
          {message}
        </div>
      )}
    </div>
  );
};

export default TestButton;


export const QuestionMarkButton = ({
  style,
  onClick = () => {},
  size = 30,
  message = "",
}) => {
  const { sUser, hideTestButtons } = useStateContext();
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      <div
        onClick={onClick}
        onMouseEnter={(e) => {
          e?.stopPropagation?.();
          setIsHovered(true);
        }}
        onMouseLeave={(e) => {
          e?.stopPropagation?.();
          setIsHovered(false);
        }}
        rules={[]}
        style={{
          backgroundColor: "black",
          borderRadius: "100%",
          cursor: "pointer",
          margin: "10px",
          width: `${size}px`,
          height: `${size}px`,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          ...style
        }}
      >
        <HiOutlineQuestionMarkCircle color={"white"} size={"100%"} />
      </div>

      {isHovered && message && (
        <div
          style={{
            position: "absolute",
            bottom: "100%",
            left: "50%",
            transform: "translateX(-50%)",
            marginBottom: "1px",
            backgroundColor: "black",
            color: "white",
            padding: "5px 5px",
            borderRadius: "4px",
            fontSize: "12px",
            whiteSpace: "nowrap",
            zIndex: 10,
            pointerEvents: "none",
          }}
        >
          {message}
        </div>
      )}
    </div>
  );
};

export const InfoButton = ({
  style,
  size = 30,
  title = "",
  buttonId = "",
  consoleData = {},

  html,
}) => {
  const { sUser, hideTestButtons } = useStateContext();
 const showMessage = () => {
  console.log(buttonId, consoleData)
  Swal?.fire({
      position: 'center',
      icon: 'info',
      title: title,
      html: html,
      width: "80%",
      showConfirmButton: true,
      //timer: 1500
    })
 }

  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      <div
        onClick={showMessage}
        rules={[]}
        style={{
          //backgroundColor: "black",
          borderRadius: "100%",
          cursor: "pointer",
          width: `${size}px`,
          height: `${size}px`,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          ...style
        }}
      >
        <IoIosInformationCircleOutline color={"#324d67"} size={"100%"} />
      </div>
    </div>
  );
};